<template>
  <div>
    <div>
      <v-card>
        <div class="d-flex pa-2 align-center channel">
          <v-card-title class="headline white--text">Category</v-card-title>
          <v-btn class="ml-auto" icon @click="close()">
            <v-icon small class="white--text">mdi-window-close</v-icon>
          </v-btn>
        </div>
        <v-card-text>
          <v-data-table
            :headers="headers"
            :items="categories"
            :search="search"
            class="border"
            show-select
            :hide-default-footer="false"
            v-model="selectedCategory"
          >
            <template v-slot:item.category_name="{ item }">
              <td>
                {{ item.category_name
                }}<span class="cate-info-text">{{ item.category_info }}</span>
              </td>
            </template>
            <template v-slot:item.sort="{ item }">
              <td>
                {{
                  selectedCategory.findIndex(it => it.id == item.id) > -1
                    ? selectedCategory.findIndex(it => it.id == item.id) + 1
                    : ""
                }}
              </td>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import { listCategories, listUserRolesByRole } from "@/graphql/Query";
import {
  createCategory,
  updateCategory,
  deleteCategory,
  createUserRoles,
  deleteUserRoles
} from "@/graphql/Mutation";

export default {
  name: "CategoryList",
  props: ["selected_categories"],
  data: () => ({
    addCategoryDialog: false,
    editCategoryDialog: false,
    deleteConfirmDialog: false,
    membersEditDialog: false,
    singleSelect: false,
    valid: true,
    categoryName: "",
    categoryEditName: "",
    errors: [],
    search: "",
    selectedCategory: [], // 그룹리스트에서 편집, 삭제를 위해 선택된 그룹
    headers: [
      {
        text: "name",
        align: "start",
        value: "category_name"
      },
      { text: "id", value: "id" },
      { text: "sort", value: "sort" }
    ],
    headersUser: [
      {
        text: "email",
        align: "start",
        value: "email"
      }
    ],
    categories: [],
    categoryHeaders: [{ text: "Category", value: "name" }]
  }),

  created() {
    this.initialize();
  },

  computed: {
    btnDisabled: function() {
      return this.selectedCategory.length <= 0;
    },
    addBtnDisabled: function() {
      return this.categories.length >= 100;
    },
    categoryNameMembersEdit: function() {
      if (this.selectedCategory.length > 0) {
        return this.selectedCategory[0].category_name;
      }
      return "";
    }
  },

  methods: {
    close() {
      const selected = this.selectedCategory.map(item => item.id);
      this.$emit("onCloseCollectionCategoryDialog", selected);
    },
    async initialize() {
      this.categories = [];
      await this.getListCategories();
      // 이미 선택된 목록 체크
      console.log("aaa", this.selected_categories);
      this.categories.forEach(item => {
        if (
          Array.isArray(this.selected_categories) &&
          this.selected_categories.find(categoryId => categoryId == item.id)
        ) {
          this.selectedCategory.push(item);
        }
      });
    },
    CategorySave() {
      this.addCategoryDialog = false;
    },

    async deleteCategory() {
      try {
        console.log();
        const channel_id = this.$store.state.channelId;
        const id = this.selectedCategory[0].id;
        console.log({ channel_id, id });
        const { data } = await this.$apollo.mutate({
          mutation: deleteCategory,
          variables: {
            input: {
              channel_id,
              id
            }
          },
          fetchPolicy: "no-cache"
        });
        if (data && data.deleteCategory) {
          this.$store.dispatch("logger", {
            menu: "Categories",
            level: "success",
            message: `Success to Delete Category [${this.categoryNameMembersEdit}] `
          });
          this.categories = this.categories.filter(function(item) {
            return item.id != id;
          });
        }
      } catch (e) {
        // console.log("[CategoryList] DeleteCategory failed", e);
        this.$store.dispatch("logger", {
          menu: "Categories",
          level: "error",
          message: `Failed to Delete Category [${this.categoryNameMembersEdit}]`
        });
      }
      this.deleteConfirmDialog = false;
    },
    deleteItem(item) {
      this.selectedId = item.id;
      this.deleteCategoryDialog = true;
    },
    openEditCategoryDialog() {
      this.categoryEditName = this.selectedCategory[0].category_name;
      this.editCategoryDialog = true;
    },
    openMembersEditDialog() {
      this.membersEditDialog = true;
      this.getListUsers();
    },
    closeEditCategoryDialog() {
      this.editCategoryDialog = false;
    },
    closeMembersEditDialog() {
      this.membersEditDialog = false;
      this.deleteMembers = [];
      this.createMembers = [];
    },
    closeAddCategoryDialog() {
      this.$refs.form.resetValidation();
      this.$refs.form.reset();
      this.addCategoryDialog = false;
    },
    async getListCategories() {
      /**
       * 채널에 해당하는 그룹목록 가져오기
       */
      const limit = undefined;
      const nextToken = undefined;
      try {
        const { data } = await this.$apollo.query({
          query: listCategories,
          variables: {
            channel_id: this.$store.state.channelId,
            limit: limit,
            nextToken: nextToken
          },
          fetchPolicy: "no-cache"
        });
        console.log("[CategoryList]", data);
        this.categories = data.listCategories.items;
        console.log(this.categories);
        this.categories.sort((a, b) =>
          a.category_name > b.category_name ? 1 : -1
        );
      } catch (e) {
        console.log("[CategoryList] listCategory failed");
      }
    },
    async createCategory() {
      /**
       * 채널에 해당그룹 생성하기
       */
      if (!this.$refs.form.validate()) return;

      try {
        console.log(this.$store.state.channelId, this.categoryName);
        const { data } = await this.$apollo.mutate({
          mutation: createCategory,
          variables: {
            input: {
              channel_id: this.$store.state.channelId,
              category_name: this.categoryName
            }
          }
        });
        if (data && data.createCategory) {
          this.categories.push(data.createCategory);
          this.categories.sort((a, b) =>
            a.category_name > b.category_name ? 1 : -1
          );

          this.$store.dispatch("logger", {
            menu: "Categories",
            level: "success",
            message: `Success to Add Category ${data.createCategory.category_name}`
          });
        }
      } catch (error) {
        if (error) {
          this.$store.dispatch("logger", {
            menu: "Categories",
            level: "error",
            message: `Fail to Add Category ${this.category_name} `
          });
        }
      }
      this.closeAddCategoryDialog();
      this.$emit("onUpdateCategoryList", this.categories);
    },
    async editCategory() {
      /**
       * 채널에 해당그룹 수정하기
       */
      if (!this.$refs.form2.validate()) return;

      try {
        console.log(
          this.$store.state.channelId,
          this.categoryEditName,
          this.selectedCategory[0].id,
          this.categories
        );
        const channel_id = this.$store.state.channelId;
        const category_name = this.categoryEditName;
        const id = this.selectedCategory[0].id;

        const { data } = await this.$apollo.mutate({
          mutation: updateCategory,
          variables: {
            input: {
              channel_id,
              category_name,
              id
            }
          }
        });

        if (data && data.updateCategory) {
          const o = this.categories.find(obj => obj.id == id);
          o.category_name = data.updateCategory.category_name;
          this.categories.sort((a, b) =>
            a.category_name > b.category_name ? 1 : -1
          );

          this.$store.dispatch("logger", {
            menu: "Categories",
            level: "success",
            message: `Success to Update Category ${this.selectedCategory[0].category_name} => ${data.updateCategory.category_name}`
          });

          this.$emit("onUpdateCategoryList", this.categories);
        }
      } catch (error) {
        if (error) {
          this.$store.dispatch("logger", {
            menu: "Categories",
            level: "error",
            message: `Fail to Update Category ${this.selectedCategory[0].category_name} => ${this.categoryEditName} `
          });
        }
      }
      this.closeEditCategoryDialog();
    },
    async editMembers() {
      const channel_id = this.$store.state.channelId;
      const role = "gu";
      const category_name = this.categoryNameMembersEdit;
      let deleteResult;
      let createResult;

      // 삭제 목록 작성
      this.selectedCategoryMembers.forEach(item => {
        const result = this.selectedUsers.find(item2 => {
          console.log(item.email, item2.email, item == item2);
          return item.email == item2.email;
        });
        console.log({ result });
        if (!result) {
          const x = {};
          x.email = item.email;
          this.deleteMembers.push(x);
        }
      });
      console.log("deleteMembers", this.deleteMembers);

      // 생성 목록 작성
      const diff = [];
      this.users.forEach(item => {
        const result = this.selectedCategoryMembers.find(item2 => {
          return item.email == item2.email;
        });
        if (!result) diff.push(item);
      });
      console.log("diff", diff);

      diff.forEach(item => {
        const result = this.selectedUsers.find(
          item2 => item.email == item2.email
        );
        if (result) {
          const x = {};
          x.email = item.email;
          this.createMembers.push(x);
        }
      });
      console.log("createMembers", this.createMembers);

      if (this.deleteMembers.length > 0) {
        console.log("삭제");
        this.deleteMembers.forEach(item => {
          item.channel_id = channel_id;
          item.role = role;
          item.category_name = category_name;
        });
        try {
          const { data } = await this.$apollo.mutate({
            mutation: deleteUserRoles,
            variables: {
              input: this.deleteMembers
            },
            fetchPolicy: "no-cache"
          });
          if (data && data.deleteUserRoles == "done") {
            deleteResult = true;
          }
        } catch (e) {
          console.log("[CategoryList] EditMembers 삭제", e);
        }
      }

      if (this.createMembers.length > 0) {
        console.log("생성");
        this.createMembers.forEach(item => {
          item.channel_id = channel_id;
          item.role = role;
          item.category_name = category_name;
        });
        try {
          const { data } = await this.$apollo.mutate({
            mutation: createUserRoles,
            variables: {
              input: this.createMembers
            },
            fetchPolicy: "no-cache"
          });
          if (data && data.createUserRoles == "done") {
            createResult = true;
          }
        } catch (e) {
          console.log("[CategoryList] EditMembers 생성", e);
        }
      }

      if (deleteResult || createResult) {
        try {
          this.$store.dispatch("logger", {
            menu: "Categories",
            level: "success",
            message: `Success to Edit Category [ ${category_name} ] members`
          });
        } catch {
          console.log("log error");
        }
      } else {
        try {
          this.$store.dispatch("logger", {
            menu: "Categories",
            level: "error",
            message: `Failed to Edit Category [ ${category_name} ] members`
          });
        } catch {
          console.log("log error");
        }
      }

      this.closeMembersEditDialog();
    },
    categoryNameRules(v) {
      if (!v) return "Category Title is required";
      if (v.length > 10) return "Title must be less than 30 characters";
      return true;
    },
    categoryEditNameRules(v) {
      if (!v) return "Live Title is required";
      if (v.length > 10) return "Title must be less than 30 characters";
      return true;
    },
    async getListUsers() {
      /**
       * userRole을 role을 기준으로 가져오기
       * 채널##gu 로 채널유저 가져와 이메일 정렬 후 users에 입력
       */
      const limit = undefined;
      const nextToken = undefined;
      const channelId = this.$store.state.channelId;
      const categoryName = this.categoryNameMembersEdit;
      const userRoleForFull = `${channelId}##gu`;
      const userRoleForSelectedCategory = `${channelId}#${categoryName}#gu`;

      // 채널 전체 유저 가져오기
      const { data } = await this.$apollo.query({
        query: listUserRolesByRole,
        variables: {
          user_role: userRoleForFull,
          limit: limit,
          nextToken: nextToken
        },
        fetchPolicy: "no-cache"
      });

      const items = data.listUserRolesByRole.items;
      this.users = items;
      console.log("users", this.users);

      // 선택 그룹에 해당하는 유저 가져오기
      const result = await this.$apollo.query({
        query: listUserRolesByRole,
        variables: {
          user_role: userRoleForSelectedCategory
        },
        fetchPolicy: "no-cache"
      });

      if (result && result.data.listUserRolesByRole.items) {
        this.selectedCategoryMembers = [
          ...result.data.listUserRolesByRole.items
        ];
        this.selectedUsers = result.data.listUserRolesByRole.items;
      }
      console.log("selectedCategoryMembers", this.selectedCategoryMembers);
    }
  }
};
</script>
<style>
.userslist {
  max-height: 200px;
}
.cate-info-text {
  font-size: 12px;
  color: rgb(146, 146, 146);
  padding-left: 5px;
}
</style>
